import jsPDF from "jspdf";
import {
    store
} from "../../index";
import moment from "moment";
import {
    imgData
} from "./letterhead";
// import Roundy from "../../services/roundy";
// var doc = new jsPDF();
var toTitleCase = function (str) {
    str = str.toLowerCase().split(' ');
    for (var i = 0; i < str.length; i++) {
        str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return str.join(' ');
};
const pdfdownload = (reportdata, startdate, enddate) => {
    var index = 0;
    var sheetNum = 1;
    var employees = store.getState().employees.employees;
    // You'll need to make your image into a Data URL
    // Use http://dataurl.net/#dataurlmaker
    var doc = new jsPDF();
    var row = 45;
    var grand_total_amount = 0;
    reportdata.map((emp, index, array) => {
        var sub_total_amount = 0;
        if (row + emp.unpaid_days.length * 6 + 21 >= 258) {
            doc.text(90, 266, "Sheet " + sheetNum);
            sheetNum += 1;
            doc.addPage();
            doc.addImage(imgData, "JPEG", 15, 10, 113, 22);
            doc.setFontType("bold");
            doc.setFontSize(12);
            doc.text(160, 20, "Unpaid Days");
            doc.setFontType("normal");
            doc.text(160, 26, "Starting " + moment(startdate).format("MM/DD/YYYY"));
            doc.text(160, 32, "Starting " + moment(enddate).format("MM/DD/YYYY"));
            row = 45;
        }
        if (index === 0) {
            doc.addImage(imgData, "JPEG", 15, 10, 113, 22);
            doc.setFontType("bold");
            doc.setFontSize(12);
            doc.text(160, 20, "Unpaid Days");
            doc.setFontType("normal");
            doc.text(160, 26, "Starting " + moment(startdate).format("MM/DD/YYYY"));
            doc.text(160, 32, "Ending" + moment(enddate).format("MM/DD/YYYY"));
        }
        doc.setFontSize(14);
        doc.setFont("helvetica");
        doc.setFontType("bold");
        doc.text(20, row, toTitleCase(emp.empname));
        doc.setFontSize(12);
        row += 6;
        doc.text(20, row, "Days Unpaid");
        //+6 pt in Y directopm per entry
        doc.setFontSize(12);
        doc.setFontType("normal");
        // doc.text(160, row - 53, vendor.workOrderNbr);
        //Charge Example
        emp.unpaid_days.map((up, i) => {
            row += 6;
            doc.text(20, row, up);
        });
        row += 7;
    });
    doc.save("Unpaid Hours " + moment(startdate).format("MM/DD/YYYY") + '-' + moment(enddate).format("MM/DD/YYYY") + ".pdf");
};

export default pdfdownload;


// WEBPACK FOOTER //
// ./src/components/pdf/unpaidReportPDFDownload.js